// extracted by mini-css-extract-plugin
export default {"listTable":"styles_listTable__XPK0z"};